import { render, staticRenderFns } from "./LiveMain.vue?vue&type=template&id=4dd3504f&scoped=true"
import script from "./LiveMain.vue?vue&type=script&lang=js"
export * from "./LiveMain.vue?vue&type=script&lang=js"
import style0 from "./LiveMain.vue?vue&type=style&index=0&id=4dd3504f&prod&scoped=true&lang=scss"
import style1 from "./LiveMain.vue?vue&type=style&index=1&id=4dd3504f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dd3504f",
  null
  
)

export default component.exports